import React, { useEffect, useState } from "react";
import DashboardPatient from "../dashboard/DashboardPatient";
import { useParams, useLocation } from "react-router-dom";
import "../../styles/customs.css";
import NICFlag from "../../images/nicaragua-flag.png";
import CRCFlag from "../../images/cr-flg.png";
import BahFlag from "../../images/bahamas-flag.png";
import USAFlag from "../../images/usa-flag.png";
import JAMFlag from "../../images/jamaica-flag.png";
import Typography from "@material-ui/core/Typography";
import Axios from "axios";
import UseUserState from "../hooks/useUserState";
import LoadingSpin from "../utils/Loading";
import { makeStyles } from "@material-ui/core/styles";
import ProfileLogo from "../../images/profile-2.svg";
import {
  Chip,
  Card,
  CardContent,
  CardActions,
  Grid,
  Box,
  Avatar,
  IconButton,
  Button,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import EventIcon from "@material-ui/icons/Event";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import LanguageIcon from "@material-ui/icons/Language";
import BusinessIcon from "@material-ui/icons/Business";
import SchoolIcon from "@material-ui/icons/School";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { resizeByLink } from "./../utils/ResizeLinkCloudinary";
import useBDocTranslator from "../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(2),
  },
  heroCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(2),
    overflow: "hidden",
  },
  heroContent: {
    padding: theme.spacing(3),
    position: "relative",
  },
  profileSection: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  avatarLarge: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    marginRight: theme.spacing(3),
    border: "4px solid rgba(255, 255, 255, 0.3)",
  },
  providerInfo: {
    flex: 1,
  },
  ratingContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  countryFlag: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    borderRadius: "50%",
    width: 40,
    height: 40,
    objectFit: "cover",
  },
  appointmentButton: {
    background: "rgba(255, 255, 255, 0.2)",
    color: "white",
    borderColor: "white",
    marginTop: theme.spacing(2),
    "&:hover": {
      background: "rgba(255, 255, 255, 0.3)",
    },
  },
  infoCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  backButton: {
    marginBottom: theme.spacing(2),
  },
  contactInfo: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    color: "rgba(255, 255, 255, 0.9)",
  },
  contactIcon: {
    marginRight: theme.spacing(1),
    fontSize: "1.2rem",
  },
  summaryCard: {
    backgroundColor: "#f8f9fa",
    border: "1px solid #e9ecef",
  },
  languageItem: {
    backgroundColor: "#f1f3f4",
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

export default function ProviderDetails() {
  const classes = useStyles();
  const location = useLocation();
  const profileImg = location.state;
  const { id } = useParams();
  const storeState = UseUserState();
  const [loading, setLoading] = useState(true);
  const [age, setAge] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [provider, setProvider] = useState({});
  const [specialty, setSpecialty] = useState([]);
  const [issuedBy, setIssuedBy] = useState([]);
  const [providerUserId, setProviderUserId] = useState("");
  let history = useHistory();

  const { t, changeDirectLanguage } = useBDocTranslator();

  const providerD = {
    studies: {
      carrera: "doctor",
      colegio: "UCV",
      fechaInicio: "september 2018",
      fechaFinal: "september 2019",
    },
    experience: [
      {
        job: "portero",
        institute: "sanatrix",
        startDate: "agust 2018",
        endDate: "december 2019",
        expSummary: "work cleanning bathrooms",
      },
      {
        job: "Anaesthesiology",
        institute: "sanatrix",
        startDate: "january 2020",
        endDate: "today",
        expSummary: "work in the department of Anaesthesiology",
      },
    ],
    lenguajes: [
      {
        lenguaje: "ingles",
        level: "high",
      },
      {
        lenguaje: "spanish",
        level: "low",
      },
    ],
  };

  const findProvider = (e) => {
    if (storeState[0].jwt) {
      Axios.get(`${process.env.REACT_APP_API_URL_BASE}/provider/review/${id}`, {
        headers: {
          Authorization: "Bearer " + storeState[0].jwt,
        },
      })
        .then((res) => {
          getBithString(res.data.dateOfBirth);
          setProvider(res.data);
          setLoading(false);
          getAge(res.dateOfBirth);
          handleSpecialties(res.data.medical_speciality);
          handleIssuedBy(res.data.issued_by);
          setProviderUserId(res.data.user_id);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    findProvider();
    changeDirectLanguage();
  }, []);

  const mathCountryFlag = (country) => {
    switch (country) {
      case "CRC":
        return CRCFlag;
      case "USA":
        return USAFlag;
      case "NIC":
        return NICFlag;
      case "TBH":
        return BahFlag;
      case "JAM":
        return JAMFlag;
      default:
        return CRCFlag;
    }
  };

  function getAge(dateString) {
    if (dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setAge(age);
    }
  }

  const getBithString = (date) => {
    if (date) {
      let dates = date.split("T");
      setBirthDate(dates[0]);
    }
  };

  const handleSpecialties = (specialties) => {
    if (specialties) {
      let specialty = Array.of(specialties.speciality_name);
      setSpecialty(specialty);
    }
  };

  const handleIssuedBy = (issuedBy) => {
    if (issuedBy) {
      let issued = Array.of(issuedBy);
      setIssuedBy(issued);
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleClick = () => {
    history.push({
      pathname: "/patient/appointments/create",
      state: { providerId: provider.id },
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    const maxRating = 5;
    const currentRating = rating || 0;

    for (let i = 1; i <= maxRating; i++) {
      stars.push(
        <Box key={i} component="span">
          {i <= currentRating ? (
            <StarIcon style={{ color: "#ffc107", fontSize: "1.2rem" }} />
          ) : (
            <StarBorderIcon style={{ color: "#ffc107", fontSize: "1.2rem" }} />
          )}
        </Box>
      );
    }
    return stars;
  };

  if (loading) {
    return (
      <DashboardPatient>
        <Container className={classes.root}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <LoadingSpin type="spokes" color="#1d3557" />
          </Box>
        </Container>
      </DashboardPatient>
    );
  }

  if (!provider.id) {
    return (
      <DashboardPatient>
        <Container className={classes.root}>
          <Card className={classes.infoCard}>
            <CardContent>
              <Typography variant="h6" align="center">
                {t("Provider not found")}
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </DashboardPatient>
    );
  }

  return (
    <DashboardPatient>
      <Container className={classes.root}>
        {/* Back Button */}
        <IconButton
          onClick={handleCancel}
          className={classes.backButton}
          color="primary"
        >
          <ArrowBackIcon />
        </IconButton>

        {/* Hero Section */}
        <Card className={classes.heroCard}>
          <CardContent className={classes.heroContent}>
            {provider.country && (
              <img
                src={mathCountryFlag(provider.country)}
                alt="Country flag"
                className={classes.countryFlag}
              />
            )}

            <div className={classes.profileSection}>
              <Avatar
                src={
                  profileImg
                    ? resizeByLink(profileImg, "upload")
                    : provider.user?.user_image?.path_resource || ProfileLogo
                }
                className={classes.avatarLarge}
              />

              <div className={classes.providerInfo}>
                <Typography variant="h4" component="h1" gutterBottom>
                  {provider.title && `${provider.title} `}
                  {`${provider.firstName} ${provider.lastname}`}
                </Typography>

                {specialty[0] && (
                  <Typography variant="h6" style={{ opacity: 0.9 }}>
                    {specialty[0]}
                  </Typography>
                )}

                {provider.rating_avg > 0 && (
                  <Box className={classes.ratingContainer}>
                    {renderStars(provider.rating_avg)}
                    <Typography variant="body2" style={{ marginLeft: 8 }}>
                      ({provider.rating_avg}/5)
                    </Typography>
                  </Box>
                )}

                {/* Contact Information */}
                {provider.phone1 && (
                  <Box className={classes.contactInfo}>
                    <PhoneIcon className={classes.contactIcon} />
                    <Typography variant="body2">{provider.phone1}</Typography>
                  </Box>
                )}

                {provider.user?.email && (
                  <Box className={classes.contactInfo}>
                    <EmailIcon className={classes.contactIcon} />
                    <Typography variant="body2">
                      {provider.user.email}
                    </Typography>
                  </Box>
                )}

                {(provider.city || provider.country) && (
                  <Box className={classes.contactInfo}>
                    <LocationOnIcon className={classes.contactIcon} />
                    <Typography variant="body2">
                      {[provider.city, provider.country]
                        .filter(Boolean)
                        .join(", ")}
                    </Typography>
                  </Box>
                )}
              </div>
            </div>

            <Button
              variant="outlined"
              size="large"
              startIcon={<EventIcon />}
              onClick={handleClick}
              className={classes.appointmentButton}
            >
              {t("New Appointment")}
            </Button>
          </CardContent>
        </Card>

        <Grid container spacing={3}>
          {/* Professional Summary */}
          {provider.summary && (
            <Grid item xs={12}>
              <Card className={`${classes.infoCard} ${classes.summaryCard}`}>
                <CardContent>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <SchoolIcon
                      style={{ marginRight: 8, verticalAlign: "middle" }}
                    />
                    {t("Professional Summary")}
                  </Typography>
                  <Typography variant="body1" paragraph>
                    {provider.summary}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            {/* Medical Information */}
            <Card className={classes.infoCard}>
              <CardContent>
                <Typography variant="h6" className={classes.sectionTitle}>
                  <VerifiedUserIcon
                    style={{ marginRight: 8, verticalAlign: "middle" }}
                  />
                  {t("Medical Information")}
                </Typography>

                <List>
                  {provider.medical_license && (
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Medical License")}
                        secondary={provider.medical_license}
                      />
                    </ListItem>
                  )}

                  {specialty[0] && (
                    <ListItem>
                      <ListItemIcon>
                        <BusinessIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Specialties")}
                        secondary={
                          <div className={classes.chipContainer}>
                            {specialty.map((item, idx) =>
                              item ? (
                                <Chip
                                  key={idx}
                                  label={item}
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                />
                              ) : null
                            )}
                          </div>
                        }
                      />
                    </ListItem>
                  )}

                  {issuedBy.length > 0 && (
                    <ListItem>
                      <ListItemIcon>
                        <VerifiedUserIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Issued By")}
                        secondary={
                          <div className={classes.chipContainer}>
                            {issuedBy.map((item, idx) => (
                              <Chip
                                key={idx}
                                label={item}
                                size="small"
                                color="secondary"
                                variant="outlined"
                              />
                            ))}
                          </div>
                        }
                      />
                    </ListItem>
                  )}
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            {/* Languages & Locations */}
            <Card className={classes.infoCard}>
              <CardContent>
                <Typography variant="h6" className={classes.sectionTitle}>
                  <LanguageIcon
                    style={{ marginRight: 8, verticalAlign: "middle" }}
                  />
                  {t("Languages & Locations")}
                </Typography>

                <List>
                  {provider.primary_language && (
                    <ListItem>
                      <ListItemIcon>
                        <LanguageIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Primary Language")}
                        secondary={provider.primary_language}
                      />
                    </ListItem>
                  )}

                  {provider.secondary_language && (
                    <ListItem>
                      <ListItemIcon>
                        <LanguageIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Secondary Language")}
                        secondary={provider.secondary_language}
                      />
                    </ListItem>
                  )}

                  {provider.provider_locations &&
                    provider.provider_locations.length > 0 && (
                      <ListItem>
                        <ListItemIcon>
                          <LocationOnIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Practice Locations")}
                          secondary={
                            <div className={classes.chipContainer}>
                              {provider.provider_locations.map(
                                (location, idx) => (
                                  <Chip
                                    key={idx}
                                    label={location.name}
                                    size="small"
                                    color="default"
                                    variant="outlined"
                                  />
                                )
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    )}
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </DashboardPatient>
  );
}
